(function() {
    angular
        .module('emarket.main.navigation')
        .controller('CategoryBigMenuController', ['$log', 'mdPanelRef', 'categories', function($log, mdPanelRef, categories) {
            var vm = this;
            var parentCategories = categories
                .filter(function(category) {
                    return !category.parentId && category.highlighted;
                })
                .slice(0, 8);
            vm.parents = parentCategories;
            vm.getChilds = function(parent) {
                return categories
                    .filter(function(category) {
                        return category.parentId === parent._id;
                    })
                    .slice(0, 8);
            };
            vm.close = function() {
                mdPanelRef.close();
            };
        }]);
}());
